import { render, staticRenderFns } from "./TeamRooms.vue?vue&type=template&id=063c42fc&scoped=true"
import script from "./TeamRooms.vue?vue&type=script&lang=js"
export * from "./TeamRooms.vue?vue&type=script&lang=js"
import style0 from "./TeamRooms.vue?vue&type=style&index=0&id=063c42fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c42fc",
  null
  
)

export default component.exports